<script lang="ts">

    import Navigation from './Navigation.svelte';
    import CircleMenu from './CircleMenu.svelte';
    import { square, deglingos, minitel } from '../store/store';
    import MinitelLogo from './MinitelLogo.svelte';
    import { scrollToAnchor, redirectTo } from '../js/common';
    import { idPageHome } from './router/router';

</script>
  
  
<!---------- STYLE ---------->
  
<style lang="scss">
    .header {
        grid-area: header;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        width: 100%;
        height: 100%;
        background-color: $color_tertiary;
        border: 1px solid $color_secondary;
        font-weight: 600;
        font-size: 1rem;
        border-radius: 4px;
        box-sizing: border-box;
        &__logo {
            display: flex;
            justify-content: space-around;
            align-items: center;
            padding: 32px 0px 0 0px;
            &__img {
                width: 285px;
                height: 285px;
                &:first-child {
                    display: block;
                }
                &:last-child {
                    display: none;
                }
            }
            &:hover &__img:last-child {
                display: block;
                width: 285px;
                height: 285px;
            }
            &:hover &__img:first-child {
                display: none;
            }
        }
        &__bottom {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
        }
        &__deglingos {
            background-color: $color_primary;
            border: none;
        }
        &__minitel {
            background-color: $color_black;
            color: $color_minitel_green;
            border: none;
        }
        &__up {
            z-index: 1000;
            width: 20px;
            height: 20px;
            position: fixed;
            right: 10px;
            bottom: 10px;
            cursor: pointer;
            &__square {
                background-image: url('../images/chevron-up-square.png');
            }
            &__deglingos {
                background-image: url('../images/chevron-up-deglingos.png');
            }
            &__minitel {
                background-image: url('../images/chevron-up-minitel.png');
            }
        }
    }

    @include large {
        .header {
            justify-content: stretch;
            font-size: 1rem;
            &__logo {
                padding: 20px 8px 0 8px;
            }
        }
    }

</style>
  
  
<!---------- TEMPLATE ---------->

<header class="header bloc" class:header__deglingos={$deglingos} class:header__minitel={$minitel}>
    <a href={"#/"} on:click|preventDefault={() => redirectTo(idPageHome)}>
        {#if $minitel}
        <MinitelLogo />
        {:else}
        <div class="header__logo">
            <img class="header__logo__img" src="./images/kortefa_logo_background_blue.svg" alt="logo blue">
            <img class="header__logo__img" src="./images/kortefa_logo_background_white.svg" alt="logo white">
        </div>
        {/if}
    </a>
    <div class="header__bottom">
        <Navigation />
        <CircleMenu />
    </div>
    <div class="header__up"
        class:header__up__square={$square}
        class:header__up__deglingos={$deglingos}
        class:header__up__minitel={$minitel}
        on:click={() => scrollToAnchor("")} title="up">&nbsp;</div>
</header>  
